export const KNOWN_COMPANIES = [
  "ABBOTT LABORATORIES",
  "ABIOMED",
  "ABBVIE INC.",
  "ADVANCED ACCELERATOR APPLICATIONS",
  "ALCON RESEARCH LLC",
  "ALCON VISION LLC",
  "ALEXION PHARMACEUTICALS, INC.",
  "ALKERMES, INC.",
  "ALNYLAM PHARMACEUTICALS INC.",
  "ALPHATEC SPINE, INC",
  "ALIGN TECHNOLOGY, INC.",
  "AMGEN INC.",
  "ANGIODYNAMICS, INC.",
  "ARTHREX, INC.",
  "ASKLEPIOS BIOPHARMACEUTICAL INC.",
  "ASTELLAS PHARMA US INC",
  "ASTRAZENECA PHARMACEUTICALS LP",
  "ASTRAZENECA UK LIMITED",
  "AXSOME THERAPEUTICS, INC.",
  "BAUSCH & LOMB AMERICAS INC.",
  "BAYER HEALTHCARE PHARMACEUTICALS INC.",
  "BECTON, DICKINSON AND COMPANY",
  "BIOGEN, INC.",
  "BIONTECH SE",
  "BOEHRINGER INGELHEIM PHARMACEUTICALS, INC.",
  "BOSTON SCIENTIFIC CORPORATION",
  "BRISTOL-MYERS SQUIBB COMPANY",
  "CELGENE CORPORATION",
  "CONVATEC INC.",
  "COOK INCORPORATED",
  "CSL PLASMA INC.",
  "DAIICHI SANKYO INC.",
  "DENTSPLY SIRONA INC",
  "DEPUY SYNTHES PRODUCTS, INC.",
  "DEPUY SYNTHES SALES, INC.",
  "DERMAVANT SCIENCES, INC.",
  "E.R. SQUIBB & SONS, L.L.C.",
  "EDGE ENDO LLC",
  "EDWARDS LIFESCIENCES CORPORATION",
  "EISAI INC.",
  "ELI LILLY AND COMPANY",
  "EMD SERONO, INC.",
  "ENCORE MEDICAL, LP",
  "ENVISTA HOLDINGS CORPORATION",
  "EXACTECH, INC.",
  "GALDERMA LABORATORIES, L.P.",
  "GE HEALTHCARE",
  "GENENTECH, INC.",
  "GENENTECH USA, INC.",
  "GENZYME CORPORATION",
  "GILEAD SCIENCES, INC.",
  "GLAXOSMITHKLINE, LLC.",
  "GLOBUS MEDICAL, INC.",
  "HENRY SCHEIN, INC.",
  "HIGHRIDGE MEDICAL LLC",
  "INARI MEDICAL, INC.",
  "INCYTE CORPORATION",
  "INTUITIVE SURGICAL, INC.",
  "ITI, INC. (D/B/A INTRA-CELLULAR THERAPIES, INC.)",
  "JANSSEN BIOTECH, INC.",
  "JANSSEN PHARMACEUTICALS, INC",
  "JANSSEN SCIENTIFIC AFFAIRS, LLC",
  "JAZZ PHARMACEUTICALS INC.",
  "JOHNSON & JOHNSON",
  "KLS-MARTIN L.P.",
  "LILLY USA, LLC",
  "LIVANOVA USA, INC.",
  "MALLINCKRODT HOSPITAL PRODUCTS INC.",
  "MEDACTA USA, INC.",
  "MEDICAL DEVICE BUSINESS SERVICES, INC.",
  "MEDTRONIC, INC.",
  "MERCK SHARP & DOHME LLC",
  "NEUROCRINE BIOSCIENCES, INC.",
  "NOVARTIS PHARMACEUTICALS CORPORATION",
  "NOVO NORDISK INC",
  "ORTHOFIX MEDICAL, INC.",
  "OTSUKA AMERICA PHARMACEUTICAL, INC.",
  "PENUMBRA, INC.",
  "PFIZER INC.",
  "PHATHOM PHARMACEUTICALS, INC.",
  "PHILIPS NORTH AMERICA LLC",
  "REGENERON HEALTHCARE SOLUTIONS, INC.",
  "REGENERON PHARMACEUTICALS, INC.",
  "RXSIGHT INC",
  "SANOFI-AVENTIS U.S. LLC",
  "SHOCKWAVE MEDICAL, INC",
  "SI-BONE, INC.",
  "SIEMENS MEDICAL SOLUTIONS USA, INC.",
  "SKYE ORTHOBIOLOGICS LLC",
  "SMITH+NEPHEW, INC.",
  "SOLVENTUM CORPORATION",
  "STRAUMANN USA LLC",
  "STRYKER CORPORATION",
  "TAKEDA PHARMACEUTICALS U.S.A., INC.",
  "TELEFLEX LLC",
  "TEVA PHARMACEUTICALS USA, INC.",
  "TREACE MEDICAL CONCEPTS, INC.",
  "UCB, INC.",
  "VERTEX PHARMACEUTICALS INCORPORATED",
  "VIIV HEALTHCARE COMPANY",
  "W. L. GORE & ASSOCIATES, INC.",
  "ZIMMER BIOMET",
  "ZIMMER BIOMET HOLDINGS, INC.",
  "ZIMVIE INC.",
];

export function titleCaseCompany(str) {
  return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}